<ui-lmiv-product [q]="queryParams()[searchQueryParam]"></ui-lmiv-product>
